import adminLayout from '@/admin/layouts/LayoutOne.vue'

export default [
    {
        path: '/loan/requests',
        name: 'LoanRequestModule',
        component: () => import('@/admin/modules/loan/LoanRequestModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    }
];